import React from 'react';
import { useFitStore } from '../../store/useFitStore';

/* ============================================================
   FirstRunBoard — the Planner's empty-roster takeover.
   A brand-new coach's first screen used to be a blank week grid
   with client-dependent buttons that did nothing; now it's one
   card with one job: get their clients in. Renders only when
   the roster is empty AND data has actually loaded (no flash
   for coaches with clients), and disappears reactively the
   moment the first client lands.
============================================================ */

const STEPS: [string, string][] = [
  ['01', 'Add your clients'],
  ['02', 'Plan their week'],
  ['03', 'Log sessions live'],
];

const FirstRunBoard: React.FC<{ name: string; onAdd: () => void }> = ({ name, onAdd }) => {
  const { user, startTour } = useFitStore();
  const first = name.split(' ')[0] || 'Coach';
  const replayTour = () => {
    if (user) localStorage.removeItem(`fitflex_tour_done:${user.id}`);
    startTour();
  };
  return (
    <div className="flex-1 flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-[520px] text-center flex flex-col items-center">
        <p className="mono-label mb-3">Welcome</p>
        <h1 className="text-[clamp(30px,5vw,42px)] font-bold tracking-tight leading-tight capitalize">
          Welcome, {first}.
        </h1>
        <p className="text-[15px] text-fit-text-secondary mt-2 mb-8">
          Bring your clients in — FitFlex builds around them.
        </p>

        <button onClick={onAdd} className="btn btn-primary btn-lg w-full max-w-[340px]">
          ＋ Add your clients
        </button>
        <p className="text-[12px] text-fit-muted mt-3">
          Spreadsheet, Google Drive, or just type them in.
        </p>
        <button onClick={replayTour} className="text-[12px] text-fit-text-secondary hover:text-white mt-4 underline underline-offset-4 decoration-fit-line">
          ▸ Take the 60-second tour first
        </button>

        {/* what happens next — one quiet hairline strip, no tour */}
        <div className="grid grid-cols-3 w-full mt-12 border-t border-fit-line">
          {STEPS.map(([n, label]) => (
            <div key={n} className="pt-4 px-2">
              <p className="mono-label">{n}</p>
              <p className="text-[12px] text-fit-text-secondary mt-1">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FirstRunBoard;
